import { apiCall } from '../../../utils/restclient'
import { methods } from '../../../utils/apiHelper'
import env from '../../../env.json'
import { Adyen } from '@quickmd-llc/design-system'
import { useAdyenIsEnabled } from './useAdyenIsEnabled'

const clientKey = env.adyenClientKey
const environment = env.adyenEnvironment === 'test' || env.adyenEnvironment === 'live' ? env.adyenEnvironment : 'test'

const getBrands = async () => {
  const brands = await apiCall(
    `/api/v1/payments/creditcards/methods${Adyen.getAdyenQueryString(true)}`,
    methods.GET,
    null,
  )
  return Array.isArray(brands) && brands.every((x) => typeof x === 'string') ? brands : []
}

export function useLocalAdyen() {
  // useAdyenIsEnabled is now a no-op shim (DS dropped the gating arg in QMD-2954);
  // call site retained until admin migrates off the flag — see follow-up.
  useAdyenIsEnabled()

  return Adyen.useAdyen({
    clientKey,
    environment,
    getBrands,
  })
}
